/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface SequenceResultData {
}

export interface SequenceUntilSuccessResultData {
}

export interface SequenceUntilFailureResultData {
}

export interface SequencePretakeoffResultData {
}

export interface SequenceConfigResultData {
}

function createBaseSequenceResultData(): SequenceResultData {
  return {};
}

export const SequenceResultData = {
  encode(_: SequenceResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SequenceResultData {
    return {};
  },

  toJSON(_: SequenceResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceResultData>, I>>(base?: I): SequenceResultData {
    return SequenceResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceResultData>, I>>(_: I): SequenceResultData {
    const message = createBaseSequenceResultData();
    return message;
  },
};

function createBaseSequenceUntilSuccessResultData(): SequenceUntilSuccessResultData {
  return {};
}

export const SequenceUntilSuccessResultData = {
  encode(_: SequenceUntilSuccessResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceUntilSuccessResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceUntilSuccessResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SequenceUntilSuccessResultData {
    return {};
  },

  toJSON(_: SequenceUntilSuccessResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceUntilSuccessResultData>, I>>(base?: I): SequenceUntilSuccessResultData {
    return SequenceUntilSuccessResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceUntilSuccessResultData>, I>>(_: I): SequenceUntilSuccessResultData {
    const message = createBaseSequenceUntilSuccessResultData();
    return message;
  },
};

function createBaseSequenceUntilFailureResultData(): SequenceUntilFailureResultData {
  return {};
}

export const SequenceUntilFailureResultData = {
  encode(_: SequenceUntilFailureResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceUntilFailureResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceUntilFailureResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SequenceUntilFailureResultData {
    return {};
  },

  toJSON(_: SequenceUntilFailureResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceUntilFailureResultData>, I>>(base?: I): SequenceUntilFailureResultData {
    return SequenceUntilFailureResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceUntilFailureResultData>, I>>(_: I): SequenceUntilFailureResultData {
    const message = createBaseSequenceUntilFailureResultData();
    return message;
  },
};

function createBaseSequencePretakeoffResultData(): SequencePretakeoffResultData {
  return {};
}

export const SequencePretakeoffResultData = {
  encode(_: SequencePretakeoffResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequencePretakeoffResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequencePretakeoffResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SequencePretakeoffResultData {
    return {};
  },

  toJSON(_: SequencePretakeoffResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SequencePretakeoffResultData>, I>>(base?: I): SequencePretakeoffResultData {
    return SequencePretakeoffResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequencePretakeoffResultData>, I>>(_: I): SequencePretakeoffResultData {
    const message = createBaseSequencePretakeoffResultData();
    return message;
  },
};

function createBaseSequenceConfigResultData(): SequenceConfigResultData {
  return {};
}

export const SequenceConfigResultData = {
  encode(_: SequenceConfigResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SequenceConfigResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSequenceConfigResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SequenceConfigResultData {
    return {};
  },

  toJSON(_: SequenceConfigResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SequenceConfigResultData>, I>>(base?: I): SequenceConfigResultData {
    return SequenceConfigResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SequenceConfigResultData>, I>>(_: I): SequenceConfigResultData {
    const message = createBaseSequenceConfigResultData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
